import { render, staticRenderFns } from "./index.vue?vue&type=template&id=22714cbc&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=22714cbc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22714cbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22714cbc')) {
      api.createRecord('22714cbc', component.options)
    } else {
      api.reload('22714cbc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=22714cbc&scoped=true", function () {
      api.rerender('22714cbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/external-api-keys/index.vue"
export default component.exports